import { Component, OnInit } from '@angular/core';
import { CommonModule, NgForOf, NgIf, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  TuiButtonModule,
  TuiLoaderModule,
  TuiSvgModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';
import { TuiInputModule } from '@taiga-ui/kit';
import { ActionLogsService, ActionLog } from '../../core/services/action-logs.service';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-logs',
  standalone: true,
  imports: [
    CommonModule,
    NgForOf,
    NgIf,
    FormsModule,
    TuiButtonModule,
    TuiLoaderModule,
    TuiSvgModule,
    TuiTextfieldControllerModule,
    TuiInputModule,
    DatePipe,
  ],
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class LogsComponent implements OnInit {
  isLoading = false;
  showSearch = false;
  searchText = '';

  filteredList: any[] = [];
  allLogs: any[] = [];

  constructor(
    private actionLogsService: ActionLogsService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  async loadLogs(): Promise<void> {
    this.isLoading = true;
    try {
      const logs: ActionLog[] = await this.actionLogsService.getAllLogs();
      
      this.allLogs = logs.map(log => {
        
        let userDisplay = 'Unknown User';
        
        if (log.user && typeof log.user === 'object' && '$oid' in log.user) {
          userDisplay = (log.user as any).$oid || 'Unknown User';
        } else if (log.user && typeof log.user === 'object') {
          const populatedUser = log.user as any;
          if (populatedUser.firstname && populatedUser.lastname) {
            userDisplay = `${populatedUser.firstname} ${populatedUser.lastname}`;
          } else if (populatedUser.name) {
            userDisplay = populatedUser.name;
          } else if (populatedUser.email) {
            userDisplay = populatedUser.email;
          } else if (populatedUser.username) {
            userDisplay = populatedUser.username;
          } else if (populatedUser._id) {
            userDisplay = populatedUser._id;
          }
        }
        
        return {
          date: new Date(log.createdAt || new Date()),
          user: userDisplay,
          action: log.action,
          description: log.details || 'No description provided',
          _id: log._id
        };
      });
      this.filteredList = [...this.allLogs];
    } catch (error) {
      console.error('Error loading logs:', error);
      console.error('Full error details:', error);
      this.filteredList = [];
      this.allLogs = [];
    } finally {
      this.isLoading = false;
    }
  }

  toggle() {
    this.showSearch = !this.showSearch;
  }

  search() {
    const query = this.searchText.trim().toLowerCase();

    if (!query) {
      this.filteredList = [...this.allLogs];
      return;
    }

    this.filteredList = this.allLogs.filter((log) => {
      const dateStr = this.formatDate(log.date);
      return (
        log.user.toLowerCase().includes(query) ||
        log.action.toLowerCase().includes(query) ||
        log.description.toLowerCase().includes(query) ||
        dateStr.includes(query)
      );
    });
  }

  resetSearch() {
    this.searchText = '';
    this.filteredList = [...this.allLogs];
  }

  formatDate(date: Date): string {
    const d = new Date(date);
    const yyyy = d.getFullYear();
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${yyyy}-${mm}-${dd}`;
  }

  refreshLogs(): void {
    this.loadLogs();
  }
}
